import actions from '@/Core.Service.Domain/MessageCenter/Users/Store/actions.js';
import getters from '@/Core.Service.Domain/MessageCenter/Users/Store/getters.js';
import mutations from '@/Core.Service.Domain/MessageCenter/Users/Store/mutations.js';

const state = {
  unreadMessagesCount: 0,
  messagesByUser: [],
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
